import TrendingDown from "@/assets/icons/trending-down.svg";
import TrendingUp from "@/assets/icons/trending-up.svg";
import { useEpisode } from "@/containers/Episode/context";
import ArrowLongRight from "@/Icons/ArrowLongRight";
import Highlight from "@components/Highlight";
const TREND_ICONS = {
  undefined: null,
  new: TrendingUp,
  unchanged: ArrowLongRight,
  falling: TrendingDown,
  rising: TrendingUp,
};

const PopularityScore = () => {
  const { show_popularity_score, popularity_score, popularity_score_trend } =
    useEpisode();

  if (!popularity_score || show_popularity_score == false) {
    return null;
  }
  return (
    <Highlight
      tooltip={L.MENTIONS_POPULARITY_SCORE_EXPLANATION}
      data-trend={`trend--${popularity_score_trend}`} //needed for tests at the moment
      icon={TREND_ICONS[popularity_score_trend]}
      label={<span data-testid="score">{popularity_score}</span>}
    />
  );
};

export default PopularityScore;
